import Axios from "axios"
import StringInput from "components/Atoms/StringInput"
import { AllBanksSelectorQuery } from "generated/graphql"
import React, { useCallback, useEffect, useState } from "react"
import useDCStore from "../dc.store"

type IFSCInputProps = {
  allBanks: AllBanksSelectorQuery["allBanks"]
  index: number
}
const IFSCInput = ({ index, allBanks }: IFSCInputProps) => {
  const [value, setValue] = useState<string>()
  const [error, setError] = useState<string | null>()
  const [ifsc, setAutocomplete] = useDCStore(
    useCallback(
      store => [
        store.state.paymentMethods[index]?.ifscCode,
        store.setBankAutocomplete,
      ],
      [index]
    )
  )

  useEffect(() => {
    setValue(ifsc)
  }, [ifsc])

  return (
    <StringInput
      required
      big={false}
      error={error}
      value={value}
      onChange={async (_, value) => {
        setValue(value)
        if (value.length === 11) {
          try {
            const response = await Axios.get(
              `https://ifsc.razorpay.com/${value}`
            )
            const serverBank = allBanks?.find(
              bank => bank.codename === response.data.BANKCODE
            )

            setAutocomplete(index, response.data, serverBank)
            setError(null)
          } catch (err) {
            setError("Invalid IFSC Code")
          }
        } else {
          setAutocomplete(index, { BANK: "", BRANCH: "" }, null)
        }
      }}
      label="IFSC"
    />
  )
}

export default IFSCInput
